export enum CategoriesLength {
  MAX_MOBILE_LENGTH = 2,
}
